//
import Model from "@/models/Model"
/**
* This class describes a authorize.
*
* @class      AAuthorize (name)
*/
export default class AInvoiceComment extends Model {
  /**
   * { function_description }
   *
   * @return     {string}  { description_of_the_return_value }
   */
  resource() {
    return 'invoice_comment'
  }
}